export const USER_ROLES = {
  INSIGHTS: 4,
  PHARMACOLOGIST: 9,
  FINANCIAL_NAVIGATION: 2,
  FUND_MANAGER: 14,
  FUND_MANAGEMENT: 15
};
